import React, { useEffect } from 'react';

import { Typography, Tabs } from 'antd';
import UIStore from '../../../stores/UIStore';
import UserStore from '../../../stores/UserStore';

import Verify from '../../../components/Verify';

import ShowPartList from 'components/Parts/ShowPartList';

import ShowGroupList from 'components/Parts/ShowGroupList';

import PartStore from 'stores/PartStore';

import { observer } from 'mobx-react';

interface IPartsProps {
    location: {
        pathname: any;
    };
    history: any;
}

const PartsList: React.FC<IPartsProps> = props => {
    useEffect(() => {
        UIStore.setSelectedKey(['parts']);
        UIStore.setDocumentTitle('Parts');
    }, []);

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    const items = [
        { label: 'Parts', key: 'part', children: <ShowPartList /> },
        { label: <div className="second-step">Groups</div>, key: 'group', children: <ShowGroupList /> },
    ];

    const onChange = (key: string) => {
        PartStore.setSelectedTab(key);
    };

    return (
        <>
            <div className="tab-part-container">
                <Tabs
                    items={items}
                    tabBarStyle={{ backgroundColor: '#FFF', marginBottom: 0 }}
                    onChange={onChange}
                    defaultActiveKey={PartStore.selectedTab}
                />
            </div>
        </>
    );
};

export default observer(PartsList);
